import React from 'react';
import PropTypes from 'prop-types';

function Bed(props) {
  const { height, width } = props;
  return (
    <svg
      width={width || '200'}
      height={height || '200'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.9502 15.75V7.5H19.7002C20.4958 7.5 21.2589 7.81607 21.8215 8.37868C22.3841 8.94129 22.7002 9.70435 22.7002 10.5V15.75"
        stroke="#63666A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1.7002 19.5V4.5" stroke="#63666A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M1.7002 15.75H22.7002V19.5"
        stroke="#63666A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9.9502 7.5H1.7002" stroke="#63666A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

Bed.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

Bed.defaultProps = {
  height: undefined,
  width: 22
};

export default Bed;
